/*
 * Refuse to add a charm-bar build that has no charms on it.
 *
 * WHY. Charmi enforces no minimum of its own, so its Add to cart will happily sell a
 * base with every slot empty. A mystery shopper did exactly that on 2026-09-07 from
 * /pages/omaha-beef and walked off with a bare $28 Wren, on a page whose own copy says
 * every bracelet starts from the steer, the football and the star. The same hole is on
 * every page that carries a builder, /pages/charm-bar included, which is why this lives
 * in the theme rather than in one client page.
 *
 * HOW IT DECIDES, measured on the live builder rather than assumed. The element
 * charmi-component-line-item reads 1 for a base with no charms, because the base is
 * itself a line, and 6 for a base with five charms. So "no charms" is a line count of
 * 1 or less. Slot images are absent even on a full build, so that second test is always
 * true today; it stays in the AND because it can only ever stop a block, never cause
 * one. Anything this cannot read confidently is left alone, since a guard that misfires
 * blocks real sales, which is worse than the hole it closes.
 *
 * This file is the only copy. /pages/omaha-beef carried an identical inline block while
 * this was staged, and that block was removed when this went live on 2026-09-07, so a
 * change to the rule belongs here and nowhere else.
 */
(function () {
  'use strict';

  function deep(root, sel, out) {
    out = out || [];
    if (!root) { return out; }
    root.querySelectorAll(sel).forEach(function (e) { out.push(e); });
    root.querySelectorAll('*').forEach(function (e) {
      if (e.shadowRoot) { deep(e.shadowRoot, sel, out); }
    });
    return out;
  }

  function section() {
    var ctx = document.querySelector('charmi-context');
    return ctx ? (ctx.closest('[id^="shopify-section"]') || ctx) : null;
  }

  function looksEmpty(sec) {
    var slots = deep(sec, 'charmi-droppable-component');
    if (!slots.length) { return false; }
    var withImage = 0;
    for (var i = 0; i < slots.length; i++) {
      if (deep(slots[i], 'img').length) { withImage++; }
    }
    return withImage === 0 && deep(sec, 'charmi-component-line-item').length <= 1;
  }

  function nag(msg) {
    var el = document.querySelector('.ens-guard-toast');
    if (!el) {
      el = document.createElement('div');
      el.className = 'ens-guard-toast';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      el.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);z-index:2147483000;'
        + 'max-width:min(92vw,420px);background:#1A1A1A;color:#fff;padding:14px 18px;border-radius:3px;'
        + 'font:600 14px/1.45 system-ui,-apple-system,Segoe UI,Roboto,sans-serif;'
        + 'box-shadow:0 6px 28px rgba(26,26,26,.3)';
      document.body.appendChild(el);
    }
    el.textContent = msg;
    el.style.display = 'block';
    if (el.hideTimer) { clearTimeout(el.hideTimer); }
    el.hideTimer = setTimeout(function () { el.style.display = 'none'; }, 7000);
  }

  document.addEventListener('click', function (ev) {
    var sec = section();
    if (!sec) { return; }
    var path = (ev.composedPath && ev.composedPath()) || [];
    var inSection = false, btn = null;
    for (var i = 0; i < path.length; i++) {
      var n = path[i];
      if (n === sec) { inSection = true; }
      if (!btn && n && n.nodeType === 1 && n.tagName === 'BUTTON'
          && /add to cart/i.test(n.textContent || '')) { btn = n; }
    }
    if (!inSection || !btn || !looksEmpty(sec)) { return; }
    ev.preventDefault();
    ev.stopPropagation();
    if (ev.stopImmediatePropagation) { ev.stopImmediatePropagation(); }
    nag('Put at least one charm on it first. The chain is priced for the charms that go on it, so an empty one is not what you want.');
  }, true);
})();
